import { combineReducers } from 'redux';
import types from 'frontend/state/actionTypes';

import { toggleReducer, setterReducer } from 'frontend/state/utils';

const showRelativeDifferenceReducer = (state = false, action = {}) => {
  const { type } = action;
  switch (type) {
    case types.TOGGLE_SHOW_RELATIVE_DIFFERENCE:
      return !state;
    default:
      return state;
  }
};

export default combineReducers({
  showRelativeDifference: showRelativeDifferenceReducer,
  preferEquipped: toggleReducer({
    toggle: types.TOGGLE_PREFER_EQUIPPED,
    initial: true,
  }),
  pawnIncludeName: toggleReducer({
    toggle: types.TOGGLE_REPORT_PAWN_NAME,
    initial: true,
  }),
  pawnIncludeSpec: toggleReducer({
    toggle: types.TOGGLE_REPORT_PAWN_SPEC,
    initial: true,
  }),
  pawnIncludeFight: toggleReducer({
    toggle: types.TOGGLE_REPORT_PAWN_FIGHT,
    initial: true,
  }),
  pawnIncludeDate: toggleReducer({
    toggle: types.TOGGLE_REPORT_PAWN_DATE,
    initial: false,
  }),
  pawnIncludeClass: toggleReducer({
    toggle: types.TOGGLE_REPORT_PAWN_CLASS,
    initial: true,
  }),
  droptimizerSort: setterReducer({
    set: types.CHOOSE_REPORT_DROPTIMIZER_SORT,
    initial: 'priority',
  }),
  droptimizerRelativeDps: toggleReducer({
    toggle: types.TOGGLE_REPORT_DROPTIMIZER_RELATIVE_DPS,
    initial: false,
  }),
  optimizeCompareAgainst: setterReducer({
    set: types.CHOOSE_REPORT_OPTIMIZE_COMPARE_AGAINST,
    initial: 'equipped',
  }),
  detailedProgress: toggleReducer({
    toggle: types.TOGGLE_DETAILED_PROGRESS,
    initial: true,
  }),
});

const baseSelector = state => state.simbot.report;
const showRelativeDifferenceSelector = state => baseSelector(state).showRelativeDifference;
const preferEquippedSelector = state => baseSelector(state).preferEquipped;

const pawnIncludeNameSelector = state => baseSelector(state).pawnIncludeName;
const pawnIncludeSpecSelector = state => baseSelector(state).pawnIncludeSpec;
const pawnIncludeFightSelector = state => baseSelector(state).pawnIncludeFight;
const pawnIncludeDateSelector = state => baseSelector(state).pawnIncludeDate;
const pawnIncludeClassSelector = state => baseSelector(state).pawnIncludeClass;

const droptimizerSortSelector = state => baseSelector(state).droptimizerSort;
const droptimizerRelativeDpsSelector = state => baseSelector(state).droptimizerRelativeDps;

const optimizeCompareAgainstSelector = state => baseSelector(state).optimizeCompareAgainst;

const detailedProgressSelector = state => baseSelector(state).detailedProgress;

export const selectors = {
  showRelativeDifference: showRelativeDifferenceSelector,
  preferEquipped: preferEquippedSelector,

  pawnIncludeName: pawnIncludeNameSelector,
  pawnIncludeSpec: pawnIncludeSpecSelector,
  pawnIncludeFight: pawnIncludeFightSelector,
  pawnIncludeDate: pawnIncludeDateSelector,
  pawnIncludeClass: pawnIncludeClassSelector,

  droptimizerSort: droptimizerSortSelector,
  droptimizerRelativeDps: droptimizerRelativeDpsSelector,

  optimizeCompareAgainst: optimizeCompareAgainstSelector,

  detailedProgress: detailedProgressSelector,
};
